import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { modalSlice } from 'logic/store/modal/modal.slice';
import { AuthenticationStepKey } from 'logic/store/authentication/authentication.model';
import { getAuthenticatedUser } from 'logic/store/authentication/authentication.selectors';
import { AppRoute } from 'app/app.route.const';
import { navigationSlice } from '../navigation/navigation.slice';

export const useRedirectToPublishOffer = (
  stepInner: AuthenticationStepKey = AuthenticationStepKey.Login
) => {
  const dispatch = useDispatch();
  const authenticatedUser = useSelector(getAuthenticatedUser);

  const handleRedirect = useCallback(() => {
    if (!authenticatedUser) {
      dispatch(
        modalSlice.actions.openAuthenticationModal({
          stepKey: stepInner,
        })
      );
    } else {
      const offerId = authenticatedUser.offer?._id;
      offerId
        ? dispatch(navigationSlice.actions.navigateTo({ path: AppRoute.PublishOffer }))
        : dispatch(navigationSlice.actions.navigateTo({ path: AppRoute.EditOffer }));
    }
  }, [dispatch, authenticatedUser]);

  return handleRedirect;
};
